import { render, staticRenderFns } from "./AdditionalSectionsPanel.vue?vue&type=template&id=2433579f&scoped=true&"
import script from "./AdditionalSectionsPanel.vue?vue&type=script&lang=js&"
export * from "./AdditionalSectionsPanel.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalSectionsPanel.vue?vue&type=style&index=0&id=2433579f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2433579f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VExpandTransition,VIcon,VSwitch,VTextField,VTooltip})
